import { render, staticRenderFns } from "./FooterList.vue?vue&type=template&id=1c15d212"
import script from "./FooterList.vue?vue&type=script&lang=js"
export * from "./FooterList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports